<script>
    import { format } from 'svelte-i18n';

    let {
        references = $bindable([""]),
        addReference = x=>x,
        removeReference = x=>x,
        pushReferences = x=>x
    } = $props();


</script>
<style>
    .reference-input{
        max-width: 94%;
    }
</style>

<div class="mb-3" style="height: 100%;overflow: hidden;clear: both;">
    <label for="name" class="d-block" style="clear: both;">{$format("page.vulnerability.references")}<span title="Requerido" class="text-danger">*</span></label>
    <div class="mt-3 mb-5">
        <button class="btn btn-default btn-xs float-start" title="Agregar más notas" onclick={()=>{event.preventDefault(); return addReference()}}>
            <span class="float-start me-1">{$format("add")} {$format("page.vulnerability.reference")}</span>
        </button>
    </div>
        {#each references as reference, i}
            <input
                type="text"
                class="form-control mt-3 reference-input float-start"
                id=""
                name={`${"references" + i.toString()}`}
                placeholder=""
                bind:value={references[i]}
                onblur={()=>pushReferences(references)}
            />
            <button class="btn btn-default float-end" title="Quitar referencia" style="margin-top:1rem; position: relative; margin-left: 0.8em;" onclick={()=>{event.preventDefault(); return removeReference(i)}}><i class="fas fa-minus" style="font-size: 1rem; color: rgba(160, 33, 40, 0.9);"></i></button>
        {/each}
</div>